module.exports = __webpack_public_path__ + "static/media/DeathRowLogo.3256e821.png";